/**
 * check.svg is a blue badge with the tick knocked *out* of it rather than
 * painted on — so the tick renders as whatever sits behind the icon. That's why
 * the design layers an 18px white circle underneath: it's what makes the tick
 * read white instead of showing the dark page through it.
 */
export function CheckIcon({ className }: { className?: string }) {
  return (
    <span className={className ?? "relative mt-[5px] block h-6 w-6 shrink-0"}>
      <span
        aria-hidden
        className="absolute left-[3px] top-[3px] h-[18px] w-[18px] rounded-full bg-white"
      />
      <img src="/get-started/check.svg" alt="" className="relative h-6 w-6" />
    </span>
  );
}
